import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

// Utils
import { DETALIZATION_MODAL_COMMON } from 'constants/detalization';
import { formatPhone } from 'utils/formatString';

// Components
import {
  Text,
  Checkbox,
} from '@beef/ui-kit';

// Styles
import styles from './styles.pcss';

const cx = classNames.bind(styles);

export const NumbersListSection = ({
  options,
  value,
  onClick,
}) => (
  <div className={cx('wrapper')}>
    <Text size="size5-b">
      {
        options.length > 1
          ? DETALIZATION_MODAL_COMMON.SEND_REPORT_FOR_CTNS
          : DETALIZATION_MODAL_COMMON.SEND_REPORT_FOR_CTN
      }
    </Text>
    <ul className={cx('list')}>
      {options.map((tel) => (
        <li key={tel.ctn} className={cx('number')}>
          <Checkbox
            checked={value.includes(tel.ctn)}
            label={`${formatPhone(tel.ctn)} ${tel.nickname || ''}`}
            name="ctn"
            onChange={onClick(tel.ctn)}
            size="small"
          />
        </li>
      ))}
    </ul>
  </div>
);

NumbersListSection.propTypes = {
  options: PropTypes.array,
  value: PropTypes.array,
  onClick: PropTypes.func,
};
